import { useRef } from 'react';
import { Container } from './index.styles';
import { DailyGrid, MonthlyGrid, WeeklyGrid } from './components';
import { WeekSlider } from '../WeekSlider';
import { useSelectionContext } from '../../selectionContext';

interface Props {
  view: CalendarView;
}

export const CalendarGrid = ({ view }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { selectedMessageIds } = useSelectionContext();

  const handlePageScrollReset = () => {
    if (containerRef.current) containerRef.current.scrollTop = 0;
  };

  return (
    <>
      {view === 'weekly' && <WeekSlider />}
      <Container
        data-testid="calendar-view-container"
        className={`calendar-${view}-grid`}
        ref={containerRef}
        $hasSelection={selectedMessageIds.length > 0}
        $view={view}
      >
        {view === 'monthly' && (
          <MonthlyGrid
            data-testid="calendar-monthly-grid"
            onRender={handlePageScrollReset}
          />
        )}
        {view === 'weekly' && (
          <WeeklyGrid
            data-testid="calendar-weekly-grid"
            onRender={handlePageScrollReset}
          />
        )}
        {view === 'daily' && <DailyGrid data-testid="calendar-daily-grid" />}
      </Container>
    </>
  );
};
